export default "__VITE_ASSET__DLig0Llf__"